import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

export const RestRelatoriosResgateXmlPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = (Arr_.dest ?? '')
    .toString()
    .replace(/[\s\u200B-\u200D\uFEFF\u0000]/g, '')
    .trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  $.ajaxSetup({headers: {Authorization: 'Bearer ' + token}});

  switch (caminho) {
    case 'resgateXmlHistoricoCompleto':
    case 'resgateXmlResgatesPorCnpj':
    case 'resgateXmlResgatesPorDocumento':
    case 'resgateXmlConsumoCobrado':
    case 'resgateXmlConsumoPorMetodo':
    case 'resgateXmlJaArmazenados':
    case 'resgateXmlTentativasInvalidas':
    case 'resgateXmlTaxaAproveitamento':
    case 'resgateXmlNfceSpDetalhado':
    case 'resgateXmlEvolucaoMensal':
    case 'resgateXmlResgatesPorUf':
    case 'resgateXmlConsumoVsLimite':
    case 'resgateXmlProjecaoConsumo':
    case 'resgateXmlHistoricoSaldo':
    case 'resgateXmlChavesPendentes':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            data: {
              pp: base64_encode('relatoriosResgate'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function () {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    default:
      return Promise.resolve([200, {erro: 'Relatório não configurado no fluxo do resgate XML. Dest: ' + caminho}]);
  }
};
